export default __webpack_public_path__ + "static/media/logo5.e5b2229e.png";